import React from 'react';
import {resolveColor} from '../../../utils/colors';


const AttentionsHistory = ({width = '14px', height = '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.75 4.25L8.91334 2.57669C8.67255 2.0951 8.55215 1.8543 8.37253 1.67837C8.21368 1.5228 8.02224 1.40448 7.81206 1.33198C7.57437 1.25 7.30516 1.25 6.76672 1.25H3.9C3.05992 1.25 2.63988 1.25 2.31901 1.41349C2.03677 1.5573 1.8073 1.78677 1.66349 2.06901C1.5 2.38988 1.5 2.80992 1.5 3.65V4.25M1.5 4.25H12.9C14.1601 4.25 14.7902 4.25 15.2715 4.49524C15.6948 4.71095 16.039 5.05516 16.2548 5.47852C16.5 5.95982 16.5 6.58988 16.5 7.85V11.15C16.5 12.4101 16.5 13.0402 16.2548 13.5215C16.039 13.9448 15.6948 14.289 15.2715 14.5048C14.7902 14.75 14.1601 14.75 12.9 14.75H5.1C3.83988 14.75 3.20982 14.75 2.72852 14.5048C2.30516 14.289 1.96095 13.9448 1.74524 13.5215C1.5 13.0402 1.5 12.4101 1.5 11.15V4.25Z"
                stroke={resolveColor(color) || '#6E6C6C'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>


    );
};
export default AttentionsHistory;
